<template>
  <div
    class="recommendations-teaser"
    :class="{
      'recommendations-teaser--flat': type && type.toLowerCase() === 'flat'
    }"
  >
    <div
      id="recommendations-teaser-headline"
      class="recommendations-teaser__headline | headline headline--type_teaser"
      :class="showHeadlineDesktop ? '' : 'hide-desktop'"
      v-if="headline && headline !== ''"
      v-html="headline"
    />
    <carousel
      class="recommendations-teaser__carousel"
      v-if="products.length"
      :slides-count="products.length"
      :slides-per-view-desktop="4"
      :slides-per-view-mobile="2"
      :slides-per-view-tablet="3"
    >
      <template
        v-for="(product, index) in products"
        :key="index"
        #[`slide-${index+1}`]
      >
        <product-box
          :clone-on-hover="true"
          :slot="`slide-${index + 1}`"
          :refresh-on="['carousel:mounted']"
          v-bind="product"
        />
      </template>
    </carousel>
  </div>
</template>

<script>
  import Carousel from '../carousel/carousel.vue';
  import ProductBox from '../productBox/productBox.vue';

  export default {
    components: {
      Carousel,
      ProductBox
    },
    props: {
      initialProducts: {
        type: Array,
        default() {
          return [];
        }
      },
      type: String,
      headline: String,
      showHeadlineDesktop: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        products: this.initialProducts
      };
    },
  };

</script>
